import { render, staticRenderFns } from "./RsaSchedaRelazioneSanitariaAnamnesiFarmacologicaEditComponent.vue?vue&type=template&id=0c04eb06"
import script from "./RsaSchedaRelazioneSanitariaAnamnesiFarmacologicaEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaRelazioneSanitariaAnamnesiFarmacologicaEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports